import { FormattedMessage, useIntl } from "@/i18n/i18n-client";
import { Mail01Icon } from "@/assets/Icons/Mail01Icon";
import { LoginMethod } from "@/templates/types/LoginFormProps";
import {
  Control,
  FieldErrors,
  UseFormRegister,
  UseFormTrigger,
} from "react-hook-form";
import EmailInputField from "@/components/Fields/EmailInputField";
import FormField from "@/components/FormField";
import StorePhoneInput from "@/components/StorePhoneInput";

interface LoginFormProps {
  method: LoginMethod;
  register: UseFormRegister<any>;
  errors: FieldErrors<any>;
  trigger: UseFormTrigger<any>;
  control: Control<any>;
  cachedCountry?: string;
}

const LoginForm = ({
  method,
  register,
  errors,
  trigger,
  control,
  cachedCountry,
}: LoginFormProps) => {
  const intl = useIntl();

  return (
    <>
      {method === LoginMethod.EMAIL ? (
        <div className="flex flex-col w-full">
          <EmailInputField
            register={register}
            error={errors?.email}
            registerOptions={{
              onChange: () => {
                if (errors.email) {
                  trigger("email");
                }
              },
            }}
            onBlur={() => {
              trigger("email");
            }}
            icon={<Mail01Icon />}
            className="!w-full"
            formFieldProps={{
              className: "w-full",
            }}
            showStrick={false}
          />
        </div>
      ) : (
        <div className="flex flex-col w-full">
          <FormField
            label={
              <FormattedMessage defaultMessage="Phone number" id="jdJhOL" />
            }
            error={errors?.phonNumber}
            className="w-full"
            showStrick={false}
          >
            <StorePhoneInput
              control={control}
              fieldName="phonNumber"
              placeholder="Enter your phone number"
              defaultCountry={cachedCountry}
              rules={{
                onChange: () => {
                  if (errors.phonNumber) {
                    trigger("phonNumber");
                  }
                },
                required: intl.formatMessage({
                  defaultMessage: "Phone number is required",
                  id: "UHu1T/",
                }),
              }}
              onBlur={() => {
                trigger("phonNumber");
              }}
            />
          </FormField>
        </div>
      )}
    </>
  );
};

export default LoginForm;
